import React from 'react';
import './App.css';
import Shop from './shop/Shop';

function App() {
  return <Shop />;
}

export default App;
